import { render } from "./BasketModel.vue?vue&type=template&id=27ec43d5&scoped=true"
import script from "./BasketModel.vue?vue&type=script&lang=js"
export * from "./BasketModel.vue?vue&type=script&lang=js"

import "./BasketModel.vue?vue&type=style&index=0&id=27ec43d5&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src546786139/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27ec43d5"]])

export default __exports__